import { CSSProperties, MouseEvent, memo } from "react";
import "./RoomName.scss";
import { Box } from "@remo-co/ui-core/src/components/Box";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { ITemplate } from "types/theater";
import { LockTableInfo } from "modules/lockTables/hooks";
import { IRoom } from "../../../../types";
import { useStyles } from "./styles";
import { lockTableIcons } from "./constants";

interface Props {
  isLockTablesEnabled: boolean;
  lockTableInfo?: LockTableInfo;
  room: IRoom;
  spaceConfig: ITemplate;
  onRightClick: (e: MouseEvent) => void;
}

export const RoomName = memo(
  ({
    isLockTablesEnabled,
    room,
    onRightClick,
    lockTableInfo,
  }: Props): JSX.Element | null => {
    const styles = useStyles();

    const nameParam = room.nameParams;

    if (!nameParam) {
      return null;
    }

    const denyEntry = lockTableInfo?.denyEntry ?? false;
    const nameStyles: CSSProperties = {
      ...nameParam,
      left: 0,
      bottom: room.height - nameParam.y,
      width: room.width,
    };

    const getLockTablesString = () => {
      if (!isLockTablesEnabled) {
        return "";
      }
      return denyEntry ? lockTableIcons.denyEntry : "";
    };

    return (
      <>
        {!room.nameTextPath && nameParam && (
          <Box className={styles.roomName}>
            <Typography
              align="center"
              key={room.code}
              className="names-ctn two-lines"
              style={nameStyles}
              onContextMenu={onRightClick}
              aria-hidden
            >
              {getLockTablesString()}
              {room.name}
            </Typography>
          </Box>
        )}
        {room.nameTextPath && nameParam && (
          <div
            className="text-path-name-container"
            key={room.code}
            onContextMenu={onRightClick}
            aria-hidden
          >
            <svg width="100%" height="100%">
              <path
                id={`text-path-${room.code}`}
                fill="none"
                stroke="none"
                d={room.nameTextPath}
              />
              <text
                style={{
                  fill: nameParam.color,
                  fontSize: nameParam?.fontSize,
                }}
                className="MuiTypography-body1"
              >
                <textPath
                  textAnchor="middle"
                  href={`#text-path-${room.code}`}
                  startOffset="50%"
                >
                  {getLockTablesString()}
                  {room.name}
                </textPath>
              </text>
            </svg>
          </div>
        )}
      </>
    );
  },
);
